/**
 * si-blog-toc-v2.js — Self Indulge Blog Enhanced TOC + Visual Features
 *
 * Features:
 * - Dual-mode TOC: inline collapsible (mobile) + sticky sidebar (desktop)
 * - Intersection Observer for active section tracking
 * - Smooth scroll with dynamic header offset
 * - Read progress bar
 * - Back-to-top button
 * - Respects prefers-reduced-motion
 */
(function () {
  'use strict';

  // ── Fix Kalles overflow:hidden on #nt_wrapper (breaks sticky) ──
  var ntWrapper = document.getElementById('nt_wrapper');
  if (ntWrapper) ntWrapper.style.overflow = 'visible';
  var layoutEl = document.querySelector('.si-article-layout');
  if (layoutEl) layoutEl.style.alignItems = 'stretch';

  // ── Find article content ───────────────────────────────────────
  var article = document.querySelector('.post-content article');
  if (!article) return;

  var allHeadings = article.querySelectorAll('h2, h3');
  if (!allHeadings.length) return;

  var h2Count = 0;
  for (var k = 0; k < allHeadings.length; k++) {
    if (allHeadings[k].tagName === 'H2') h2Count++;
  }
  if (h2Count < 2) return;

  var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // ── Ensure headings have IDs ───────────────────────────────────
  var tocItems = [];
  for (var i = 0; i < allHeadings.length; i++) {
    var h = allHeadings[i];
    if (!h.id) {
      h.id = 'section-' + (i + 1) + '-' + h.textContent.trim().toLowerCase()
        .replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '').substring(0, 50);
    }
    tocItems.push({
      id: h.id,
      text: h.textContent.trim(),
      level: h.tagName === 'H3' ? 3 : 2
    });
  }

  // ── Detect header height for scroll offset ─────────────────────
  function getHeaderOffset() {
    var header = document.querySelector('#shopify-section-header') ||
                 document.querySelector('header') ||
                 document.querySelector('.header_4');
    return header ? header.offsetHeight + 20 : 80;
  }

  // ── Smooth scroll to element ───────────────────────────────────
  function scrollToId(id) {
    var el = document.getElementById(id);
    if (!el) return;
    var offset = getHeaderOffset();
    var top = el.getBoundingClientRect().top + window.pageYOffset - offset;

    if (prefersReducedMotion) {
      window.scrollTo(0, top);
    } else {
      window.scrollTo({ top: top, behavior: 'smooth' });
    }
  }

  // ── Build inline TOC (mobile — <details>) ─────────────────────
  var inlineContainer = document.getElementById('si-toc-inline');
  if (inlineContainer) {
    var details = document.createElement('details');
    details.className = 'si-toc';

    var summary = document.createElement('summary');
    summary.className = 'si-toc__title';
    summary.textContent = 'In This Article (' + h2Count + ' sections)';
    details.appendChild(summary);

    var ol = document.createElement('ol');
    ol.className = 'si-toc__list';

    for (var j = 0; j < tocItems.length; j++) {
      var li = document.createElement('li');
      if (tocItems[j].level === 3) li.className = 'si-toc__item--sub';
      var a = document.createElement('a');
      a.href = '#' + tocItems[j].id;
      a.textContent = tocItems[j].text;
      a.addEventListener('click', (function (id) {
        return function (e) {
          e.preventDefault();
          scrollToId(id);
        };
      })(tocItems[j].id));
      li.appendChild(a);
      ol.appendChild(li);
    }

    details.appendChild(ol);
    inlineContainer.appendChild(details);
  }

  // ── Build sidebar TOC (desktop) ────────────────────────────────
  var sidebarNav = document.getElementById('si-toc-sidebar-nav');
  var sidebarLinks = [];

  if (sidebarNav) {
    var navList = document.createElement('ul');
    navList.className = 'si-toc-sidebar__nav';

    for (var s = 0; s < tocItems.length; s++) {
      var sLi = document.createElement('li');
      var sA = document.createElement('a');
      sA.href = '#' + tocItems[s].id;
      sA.textContent = tocItems[s].text;
      sA.setAttribute('data-level', tocItems[s].level);
      sA.setAttribute('data-target', tocItems[s].id);
      sA.addEventListener('click', (function (id) {
        return function (e) {
          e.preventDefault();
          scrollToId(id);
        };
      })(tocItems[s].id));
      sLi.appendChild(sA);
      navList.appendChild(sLi);
      sidebarLinks.push(sA);
    }

    sidebarNav.appendChild(navList);

    // Dynamic sticky offset
    var sidebarInner = document.querySelector('.si-toc-sidebar__inner');
    if (sidebarInner) {
      var stickyTop = getHeaderOffset() + 10;
      sidebarInner.style.top = stickyTop + 'px';
    }
  }

  // ── Intersection Observer for active section ───────────────────
  if (sidebarLinks.length > 0 && 'IntersectionObserver' in window) {
    var activeLink = null;

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          if (activeLink) {
            activeLink.classList.remove('si-toc--active');
            activeLink.removeAttribute('aria-current');
          }
          for (var l = 0; l < sidebarLinks.length; l++) {
            if (sidebarLinks[l].getAttribute('data-target') === entry.target.id) {
              sidebarLinks[l].classList.add('si-toc--active');
              sidebarLinks[l].setAttribute('aria-current', 'true');
              activeLink = sidebarLinks[l];

              // Scroll sidebar to keep active item visible
              var navContainer = sidebarLinks[l].closest('.si-toc-sidebar__inner');
              if (navContainer) {
                var linkTop = sidebarLinks[l].offsetTop;
                var containerHeight = navContainer.clientHeight;
                var scrollTop = navContainer.scrollTop;
                if (linkTop < scrollTop || linkTop > scrollTop + containerHeight - 40) {
                  navContainer.scrollTop = linkTop - containerHeight / 3;
                }
              }
              break;
            }
          }
        }
      });
    }, {
      rootMargin: '-15% 0px -55% 0px',
      threshold: 0
    });

    for (var o = 0; o < allHeadings.length; o++) {
      observer.observe(allHeadings[o]);
    }
  }

  // ── Progress bar ───────────────────────────────────────────────
  var progressBar = document.querySelector('.si-progress-bar');
  var articleTop = article.offsetTop;
  var articleHeight = article.offsetHeight;

  // Accessibility: add progressbar role
  if (progressBar) {
    progressBar.setAttribute('role', 'progressbar');
    progressBar.setAttribute('aria-label', 'Reading progress');
    progressBar.setAttribute('aria-valuemin', '0');
    progressBar.setAttribute('aria-valuemax', '100');
    progressBar.setAttribute('aria-valuenow', '0');
    progressBar.removeAttribute('aria-hidden');
  }

  function updateProgress() {
    if (!progressBar) return;
    var scrolled = window.pageYOffset;
    var start = articleTop - window.innerHeight * 0.3;
    var end = articleTop + articleHeight - window.innerHeight * 0.5;
    var progress = Math.max(0, Math.min(1, (scrolled - start) / (end - start)));
    progressBar.style.transform = 'scaleX(' + progress + ')';
    progressBar.setAttribute('aria-valuenow', Math.round(progress * 100));
  }

  // ── Back-to-top button ─────────────────────────────────────────
  var backBtn = document.querySelector('.si-back-to-top');

  function updateBackToTop() {
    if (!backBtn) return;
    if (window.pageYOffset > 500) {
      backBtn.classList.add('si-back-to-top--visible');
    } else {
      backBtn.classList.remove('si-back-to-top--visible');
    }
  }

  if (backBtn) {
    backBtn.addEventListener('click', function () {
      if (prefersReducedMotion) {
        window.scrollTo(0, 0);
      } else {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }
    });
  }

  // ── Scroll handler (throttled) ─────────────────────────────────
  var ticking = false;
  window.addEventListener('scroll', function () {
    if (!ticking) {
      window.requestAnimationFrame(function () {
        updateProgress();
        updateBackToTop();
        ticking = false;
      });
      ticking = true;
    }
  }, { passive: true });

  // Initial state
  updateProgress();
  updateBackToTop();

  // ── FAQPage structured data ──────────────────────────────────────
  var faqItems = document.querySelectorAll('.si-faq-item');
  if (faqItems.length > 0) {
    var faqEntries = [];
    for (var f = 0; f < faqItems.length; f++) {
      var q = faqItems[f].querySelector('.si-faq-q');
      var a = faqItems[f].querySelector('.si-faq-a');
      if (q && a) {
        faqEntries.push({
          '@type': 'Question',
          'name': q.textContent.trim(),
          'acceptedAnswer': {
            '@type': 'Answer',
            'text': a.textContent.trim()
          }
        });
      }
    }
    if (faqEntries.length > 0) {
      var faqSchema = document.createElement('script');
      faqSchema.type = 'application/ld+json';
      faqSchema.textContent = JSON.stringify({
        '@context': 'https://schema.org',
        '@type': 'FAQPage',
        'mainEntity': faqEntries
      });
      document.head.appendChild(faqSchema);
    }
  }

})();
